<template>
  <HeroScene />
</template>

<script>
import HeroScene from '@/components/HeroScene.vue'

export default {
  name: 'App',
  components: { HeroScene }
}
</script>

<style>
:global(body) {
  margin: 0;
  min-height: 100vh;
  background: #000;
  color: #fcfcfc;
  font-family: 'Space Grotesk', 'Inter', system-ui, sans-serif;
}

#app {
  min-height: 100vh;
}
</style>